<template>
    <v-container class="auth" fluid>
        <v-form v-show="stage === 'auth'" lazy-validation ref="authForm" v-model="isValidAuthForm">
            <v-row justify="center">
                <v-col cols="12" sm="8" md="4" xl="2">
                    <p>Для входа укажите свой номер телефона. На него будет выслан СМС с кодом.</p>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="8" md="4" xl="2">
                    <v-form @submit.prevent="sendCode">
                        <v-text-field
                            v-model="phone"
                            v-mask="phoneFieldMask"
                            solo
                            outlined
                            hide-details
                            label="Телефон"
                            placeholder="+7 (xxx) xxx-xx-xx"
                            required
                            :rules="[rules.required]"
                            type="tel"
                            class="mb-4"
                        />
                        <v-btn
                            block
                            color="secondary"
                            :disabled="!isValidAuthForm"
                            @click="sendCode()"
                        >
                            Отправить код
                        </v-btn>
                    </v-form>
                </v-col>
            </v-row>
        </v-form>

        <v-form v-show="stage === 'oneTimeCode'" lazy-validation ref="codeForm" v-model="isValidCodeForm">
            <v-row justify="center">
                <v-col cols="12" sm="8" md="4" xl="2">
                    <p>На номер {{ phone }}, был выслан код.</p>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="8" md="4" xl="2">
                    <v-form @submit.prevent="signIn">
                        <v-text-field
                            v-model="confirmCode"
                            v-mask="codeFieldMask"
                            autocomplete="one-time-code"
                            solo
                            outlined
                            hide-details
                            id="single-factor-code-text-field"
                            label="Код из СМС"
                            required
                            :rules="[rules.required, rules.length]"
                            class="mb-4"
                        />

                        <v-btn
                            block
                            class="mb-2"
                            color="secondary"
                            @click="signIn()"
                        >
                            Войти
                        </v-btn>

                        <v-btn
                            block
                            color="white"
                            disabled
                            text
                        >
                            Выслать повторно через: 2 мин.
                        </v-btn>
                    </v-form>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
    import { mask } from 'vue-the-mask'

    const oneTimeCodeLength = 6

    export default {
        name: 'SignInScreen',

        directives: {
            mask,
        },

        data: () => ({
            phone: '',
            confirmCode: '',
            stage: 'auth', // auth | oneTimeCode,

            phoneFieldMask: '+7 (###) ### ## ##',
            isValidAuthForm: false,

            codeFieldMask: '######',
            isValidCodeForm: false,

            rules: {
                required: value => !!value || 'Обязательное поле',
                length: value => (value && value.toString().length === oneTimeCodeLength) || `Минимум ${oneTimeCodeLength} символов`,
            },
        }),

        mounted() {
            if (this.$route.query.telnum !== undefined) {
                this.phone = this.$route.query.telnum
                this.sendCode()
            }
        },

        methods: {
            async signIn() {
                if (this.$refs.codeForm.validate()) {
                    try {
                        await this.$store.dispatch('auth/signIn', {
                            phone: this.phone,
                            code: this.confirmCode,
                        })

                        await this.$router.push({ name: 'Home' })
                    } catch (error) {
                        await this.$root.pushNotification({
                            text: error.message,
                            color: 'error',
                        })
                    }
                }
            },

            async sendCode() {
                if (this.$refs.authForm.validate()) {
                    try {
                        await this.$store.dispatch('auth/sendCode', { phone: this.phone })

                        this.stage = 'oneTimeCode'
                    } catch (error) {
                        await this.$root.pushNotification({
                            text: error.message,
                            color: 'error',
                        })
                    }
                }
            },
        },
    }
</script>

<style>
    .auth .v-input {
        border-radius: 8px;
        background: #FFF;
    }
    .auth input {
        color: #36393B;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 140%;
    }
    .auth .v-input .v-input__slot {
        box-shadow: none !important;
    }
</style>
